import type { Workspace } from "#app/lib/data/workspace-context";

/**
 * The invites the app gates on: the viewer's `invited` rows, oldest first,
 * skipping a workspace in its deletion grace — joining a frozen workspace is
 * a dead end, so it lists in the picker with its countdown instead.
 */
export function pendingInviteIds(workspaces: readonly Workspace[]): string[] {
  return workspaces
    .filter((w) => w.memberStatus === "invited" && !w.deletion)
    .sort((a, b) =>
      (a.viewerInvitedAt ?? "").localeCompare(b.viewerInvitedAt ?? ""),
    )
    .map((w) => w.workspaceId);
}
